export * from './browserCookieStorage';
export * from './cookieAuthStorageAdapter';
export * from './createClient';
export * from './types';

export {
	parseCookies,
	serializeCookie,
	parseSupabaseCookie,
	stringifySupabaseSession,
	isBrowser,
	DEFAULT_COOKIE_OPTIONS
} from './utils';
